/* eslint-disable */
import { useEffect, useState } from "react";

import { EventSourcePolyfill } from "event-source-polyfill";
import storage from "utils/storage";

export const useEventSource = (url: string, startFetch: boolean) => {
  const initData = "";
  const [data, setData] = useState(initData);
  const [complete, setComplete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  // eslint-disable-next-line
  useEffect(() => {
    const token = storage.getToken();
    if (token) {
      if (startFetch) {
        const source = new EventSourcePolyfill(url, {
          withCredentials: false,
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "1",
            "Access-Control-Allow-Headers": "*",
          },
        });
        // let newData: any[] = []
        setIsLoading(true);
        setComplete(false);

        source.onmessage = (event: any) => {
          // eslint-disable-next-line
          const eventData = event.data;
          if (eventData) {
            setIsLoading(false);
            setComplete(true);
            // eslint-disable-next-line
            source.close();
            // eslint-disable-next-line
            setData(eventData);
          }
        };

        source.onerror = () => {
          setIsLoading(false);
          setComplete(true);
          source.close();
        };

        return () => {
          source.close();
        };
      }
    }
  }, [url, startFetch]);

  return {
    data,
    isComplete: complete,
    isLoading,
  };
};

export default useEventSource;
